const blogsData = [
    {
        id: 1,
        title: 'Are you using chatgpt/ ai to create your cover letter or resume?',
        description: `Hello buddies,I will share my experience with this tools when i applied for jobs.
the process of applying for a job - while filling the application make sure you attached a cover letter along with it.
and your resume and cover letter should align with the id.`,
        tags: ['Job Search', 'Chatgpt'],
        readTime : ['5 time read'],
        publishedAt: ['16th July, 2024'],
        featuredImage : 'https://firebasestorage.googleapis.com/v0/b/my-website-9842b.appspot.com/o/chatgptimage.jpg?alt=media&token=73308fa7-d435-4295-9323-dc7943fd8ba6',
        content : [
            {
                type: 'text',
                text: `Hello buddies,I will share my experience with this tools when i applied for jobs.
the process of applying for a job - while filling the application make sure you attached a cover letter along with it.
and your resume and cover letter should align with the id. 
if there is no option for cover letter - mail to the respective hr including job id, and cover letter.
and final thing if you didn't got any response(both positive or negative) then followup them with a email. this process ensures that you read the jd and are fully interested in that position.`
            },
            {
                type: 'text',
                text : `If you are applying for 1-2 jobs daily then you can make your own cover letter by maintaining a standard template and make changes on your
own according to the roles and responsiilities mentioned in the jd - tailor your resume mf.
otherwise writing cover letter for 100 s of jobs daily is a tedious task and consumes lots of time.
so to save your time and make good cover letters or follow up mail i strongly recommed you to use AI/ chatgpt/.
But how to really use them to get the 100% and get better results.
the easiest way to create a cover letter is to copy your resume and paste it in the chat gpt and ask to parse your resume.
and in the next prompt tell it to make a cover letter with your above resume. this is your standard template.
or paste your job description in the question and ask to make a cover letter based on the job description and the resume.
then boom, chatgpt created your cover letter without any efforts.
but there's a small catch in this approach, sometimes chatgpt overthinks and adds all the technologies skills mentioned in the 
job description to your resume, you may say there is no problem with it right?.,`
            },
            {
                type : 'image',
                image : `https://firebasestorage.googleapis.com/v0/b/my-website-9842b.appspot.com/o/chatgptimage.jpg?alt=media&token=73308fa7-d435-4295-9323-dc7943fd8ba6`,
            },
            {
                type : 'text',
                text : `I asked it to make a cover letter providing all the details, and the result was shocking, 
I dont want to reveal the company name but as you can see in the image, it added the projects of that specific company
as my achivements, i am like what, how is this even possible.
and as i applied hundreds of jobs daily, went through many of the ai made cover letters and overlooked this one, which i sent to hr of that company.
I got a call from that hr as they are also shocked to see someone with 23 years age completing 200 erp projects. i apolozized for my mistake.
and from then i am checking every letter given by AI. so if you are using AI for your works make sure, you enter the prompt very clearly or cross verify the solution. `
            },
        ]
    }
]

export default blogsData;